<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="4" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
      <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12" class="pb-0">
            <div class="text-md-h4 text-h5" :style="textColor">Locations</div>
          </v-col>
          <v-col cols="12" class="pb-1">
            <div class="text-subtitle-2">For locations, you can upload a list or enter each individually below.</div>
          </v-col>

          <v-col cols="12" class="mt-8">
            <v-combobox
              v-model="employeeWorkStates"
              :items="states"
              item-value="Abbr"
              item-text="Full"
              hide-selected
              outlined
              multiple
              small-chips
              :return-object="false"
              label="*List ALL state(s) in which employees are working or residing"
              persistent-hint
              hint="Please notify Landrum ASAP if there is any change to the states listed above"
              class="rounded-lg"
            >
              <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip
                  v-if="item !== ''"
                  v-bind="attrs"
                  :color="`${item.color} lighten-3`"
                  :input-value="selected"
                  label
                  small
                >
                  <span class="pr-2">
                    {{ item }}
                  </span>
                  <v-icon
                    small
                    @click="parent.selectItem(item)"
                  >
                    $delete
                  </v-icon>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
          <v-col
            cols="12"
            class="mt-5"
          >
            <div class="text-md-body-1 text-body-2">Do you have multiple office locations, not including job sites?</div>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="multipleLocations"
              mandatory
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12" v-if="this.multipleLocations === true">
            <div class="text-body-1">Please upload a list or add them individually below</div>
          </v-col>

          <v-col cols="12" v-if="this.multipleLocations === true">
            <v-btn
              color="secondary"
              outlined
              :loading="btn1Loading"
              @click="btn1Loading = true; fileImport('EmployeeStates')"
            >
              <template v-slot:loader>
                <v-progress-linear
                  :value="uploadProgress"
                  height="100%"
                  :rotate="-90"
                  color="secondary"
                ></v-progress-linear>
              </template>
              Upload
            </v-btn>
            <div class="text-caption">{{ employeeStates }}</div>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept=".txt, .doc, .docx, .xls, .xlsx, .pdf"
              aria-label="Upload"
              @change="onFileChanged"
            >
          </v-col>

          <v-col cols="12">
            <v-card
              flat
              outlined
              rounded="lg"
              v-for="(item, index) in officeLocations"
              :key="index"
              class="mb-5"
            >
              <v-row class="mx-5">
                <v-col cols="12" class="d-flex-column">
                  <div class="d-flex justify-center text-h6 text-xs-subtitle-2">Location #{{ index + 1 }}</div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="item.address"
                    outlined
                    label="Street Address"
                    class="rounded-lg"
                    hide-details
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    outlined
                    label="City"
                    hide-details
                    class="rounded-lg"
                    v-model="item.city"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="2">
                  <v-combobox
                    v-model="item.state"
                    :items="states"
                    item-value="Abbr"
                    item-text="Full"
                    outlined
                    label="State"
                    class="rounded-lg"
                    hide-details
                    :return-object="false"
                  ></v-combobox>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    outlined
                    label="Postal Code"
                    hide-details
                    class="rounded-lg"
                    v-model="item.zip"
                  ></v-text-field>
                </v-col>

              </v-row>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  large
                  @click="removeLocation(index)"
                >
                  <v-icon left>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="12" v-if="this.multipleLocations === true">
            <v-btn
              color="secondary"
              outlined
              @click="addLocation"
            >
              Add Location
            </v-btn>
          </v-col>

          <BtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import States from '@/Data/States';
import BtnContinue from '../../btnContinue.vue';

export default {
  name: 'StepFour',
  components: {
    BtnContinue,
  },
  data: () => ({
    select: [],
    states: States,
    btn1Loading: false,
    category: '',
    type: 'Prospect',
    action: 'upsert',
    uploadProgress: 0,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    locationToggleText() {
      if (this.multipleLocations === false) {
        return 'Do you have multiple office locations, not including job sites?';
      }

      return 'Please upload a list or add them individually below';
    },
    statez() {
      return this.$store.state.prospectPacket.companyInfo.employeeWorkStates;
    },
    multipleLocations: {
      get() {
        return this.$store.state.prospectPacket.flags.officeLocations;
      },
      set(value) {
        this.$store.commit('updateHasMultipleOfficeLocations', value);
      },
    },
    officeLocations: {
      get() {
        return this.$store.state.prospectPacket.officeLocations;
      },
      set(value) {
        this.$store.commit('updateOfficeLocations', value);
      },
    },
    employeeWorkStates: {
      get() {
        if (this.statez === null) {
          return [];
        }
        return this.statez.split(',')
          .map((value) => value.trim());
      },
      set(value) {
        if (value.length === 0) {
          this.$store.commit('updateEmployeeWorkStates', null);
        } else {
          this.$store.commit('updateEmployeeWorkStates', value.join(', '));
        }
      },
    },
    employeeStates: {
      get() {
        const { documents } = this.$store.state.prospectPacket;
        const document = documents.find((x) => x.category === 'EmployeeStates');
        if (document === undefined) {
          return '';
        }
        return document.name;
      },
    },
  },
  methods: {
    addLocation() {
      const location = {
        address: '',
        city: '',
        state: '',
        zip: '',
      };

      this.officeLocations.push(location);
    },
    removeLocation(value) {
      this.officeLocations.splice(value, 1);
    },
    updateProgress(value) {
      this.uploadProgress = value;
    },
    fileImport(value) {
      this.category = value;

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.btn1Loading = true;
      // eslint-disable-next-line prefer-destructuring
      this.selectedFile = e.target.files[0];

      if (this.selectedFile === undefined) {
        this.btnLoading = false;
        this.uploadProgress = 0;
        return;
      }

      const file = {
        document: this.selectedFile,
        category: this.category,
        type: this.type,
        action: this.action,
      };

      this.$store.dispatch('uploadDocument', {
        file,
        progress: (event) => this.updateProgress(event),
      }).then(() => {
        this.btn1Loading = false;
        this.uploadProgress = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
